import {matchPath} from 'react-router-dom';
/** Published route grammar, used only to validate optional navigation memory. */
export const officialRoutes = [
 '/', '/home', '/items', '/tasks', '/events', '/space', '/space/manage', '/projects', '/search',
 '/inbox', '/capture/new', '/captures/:id', '/captures/:id/edit', '/captures/:id/history',
 '/settings/data', '/settings/backup', '/trash',
 ...['tasks','events','projects','resources','decisions','diaryEntries'].flatMap(p=>['/'+p,'/'+p+'/new','/'+p+'/:id','/'+p+'/:id/edit']),
 '/sop',...['history','manage','pinned','recent','drafts'].map(p=>'/sop/'+p),
 '/sop/templates/new','/sop/templates/:id','/sop/templates/:id/edit','/sop/runs/:id',
] as const;
export function isOfficialPath(value:string) {return officialRoutes.some(path=>matchPath({path,end:true},value.split(/[?#]/)[0]));}
